import { Bell, FolderKanban, Menu, MessageCircleQuestion, Plus, StickyNote } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { spaceOf } from "@/lib/spaces";
import { SpaceAvatar } from "@/components/SpaceAvatar";
import { NotificationBell } from "@/components/NotificationBell";
import { AskButton } from "@/components/ai/AskSheet";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const ADD = [
  { type: "reminder", label: "Reminder", hint: "Emails at a set time", icon: Bell },
  { type: "project", label: "Project", hint: "Multi-day work", icon: FolderKanban },
  { type: "note", label: "Note", hint: "No email", icon: StickyNote },
  { type: "thought", label: "Thought to discuss", hint: "Raise with the team", icon: MessageCircleQuestion },
];

export const Header = ({ onMenu }) => {
  const { space, openAdd } = useApp();
  const s = spaceOf(space);
  return (
    <header className="sticky top-0 z-30 border-b bg-background/70 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-[1400px] items-center gap-3 px-5 sm:px-8 lg:px-10">
        <button onClick={onMenu} className="rounded-md p-2 text-muted-foreground hover:bg-white/5 lg:hidden" data-testid="mobile-menu-button">
          <Menu className="h-5 w-5" />
        </button>
        <div className="flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm" data-testid="current-space-chip">
          <SpaceAvatar space={space} />
          <span className="font-medium">{space === "all" ? "All spaces" : `${s.name}'s space`}</span>
        </div>
        <div className="ml-auto flex items-center gap-2">
          <span className="hidden font-mono text-[11px] text-muted-foreground md:inline">Ctrl K</span>
          <AskButton />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button data-testid="quick-add-trigger" className="flex h-10 items-center gap-2 rounded-full bg-primary px-5 text-sm font-semibold text-primary-foreground transition-colors hover:bg-white">
                <Plus className="h-4 w-4" /> <span className="hidden sm:inline">Quick add</span>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-64">
              <DropdownMenuLabel className="text-xs uppercase tracking-wider text-muted-foreground">Add to {s.key === "all" ? "your space" : `${s.name}'s space`}</DropdownMenuLabel>
              <DropdownMenuSeparator />
              {ADD.map(({ type, label, hint, icon: Icon }) => (
                <DropdownMenuItem key={type} onClick={() => openAdd(type)} data-testid={`quick-add-${type}`} className="gap-3 py-2.5">
                  <Icon className="h-4 w-4 text-muted-foreground" />
                  <div><p className="text-sm font-medium">{label}</p><p className="text-xs text-muted-foreground">{hint}</p></div>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
          <NotificationBell />
        </div>
      </div>
    </header>
  );
};
